module.exports = __webpack_public_path__ + "static/media/logo_nj.c75456fc.png";